import {WIDGET_MAPPER} from '../index';

const convertToDashboardSettings = (savedDashboardSettings) => {
  const generatedLayouts = {
    lg: [],
    md: [],
    sm: [],
  };
  const widgetsArr = [];

  for (const [uuid, widget] of Object.entries(savedDashboardSettings)) {
    const widgetType = widget.widgetType;

    const selectedWidget = WIDGET_MAPPER[widgetType];

    widgetsArr.push({
      uuid: uuid,
      component: selectedWidget.component,
      widgetType: widgetType,
      settings: widget.settings,
    });

    const widgetHeight = selectedWidget.height;
    const widgetWidth = selectedWidget.width;

    generatedLayouts.lg.push({
      ...widget.location.lg,
      h: widgetHeight.lg,
      w: widgetWidth.lg,
      i: uuid,
    });
    generatedLayouts.md.push({
      ...widget.location.md,
      h: widgetHeight.md,
      w: widgetWidth.md,
      i: uuid,
    });
    generatedLayouts.sm.push({
      ...widget.location.sm,
      h: widgetHeight.sm,
      w: widgetWidth.sm,
      i: uuid,
    });
  }

  return {
    layouts: generatedLayouts,
    widgets: widgetsArr,
  };
};

const newWidgetLocations = (newWidgetType, oldWidgetObj) => {
  const cols = {lg: 32, md: 24, sm: 8};

  const returnObj = {
    lg: {x: 0, y: 0},
    md: {x: 0, y: 0},
    sm: {x: 0, y: 0},
  };


  const newWidgetWidthSettings = WIDGET_MAPPER[newWidgetType].width;

  for (const widgetData of Object.values(oldWidgetObj)) {
    const currentWidgetType = widgetData.widgetType;
    const currentWidgetWidthSettings = WIDGET_MAPPER[currentWidgetType].width;
    for (const [size, position] of Object.entries(widgetData.location)) {
      // if the position is lower than what's currently found do check
      if (returnObj[size].y <= position.y) {
        // check if this is the farthest location right we have for the depth
        if (returnObj[size].x < position.x + currentWidgetWidthSettings[size]) {
          const farthestPointRight = position.x + currentWidgetWidthSettings[size];
          if (farthestPointRight + newWidgetWidthSettings[size] <= cols[size]) {
            returnObj[size] = {x: farthestPointRight, y: position.y};
          } else {
            returnObj[size] = {x: 0, y: (position.y + 1)};
          }
        }
      }
    }
  }

  return returnObj;
};

const generatePanelsLabelArray = (panelsObj) => {
  // Return an array of objects which contains the panelRn, panel label and panel rank.
  // The array is sorted by rank.
  const sortedPanelLabelArr = Object.entries(panelsObj)
      .map(([panelRn, panelData]) => ({panelRn, label: panelData.label, rank: panelData.rank}))
      .sort((a, b) => a.rank - b.rank);

  return sortedPanelLabelArr;
};

export {
  convertToDashboardSettings,
  newWidgetLocations,
  generatePanelsLabelArray,
};
